import omitBy from 'lodash/omitBy';
import isNil from 'lodash/isNil';

export function omitEmptyFields<T extends object>(obj: T): T {
  return omitBy(obj, (value) => isNil(value) || value === '') as T;
}
